(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', '../Link', 'prop-types'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('../Link'), require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.Link, global.propTypes);
    global.SupportLinks = mod.exports;
  }
})(this, function (exports, _react, _Link, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _Link2 = _interopRequireDefault(_Link);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var SupportLinks = function (_React$Component) {
    _inherits(SupportLinks, _React$Component);

    function SupportLinks() {
      _classCallCheck(this, SupportLinks);

      return _possibleConstructorReturn(this, (SupportLinks.__proto__ || Object.getPrototypeOf(SupportLinks)).apply(this, arguments));
    }

    _createClass(SupportLinks, [{
      key: 'buildLinks',
      value: function buildLinks() {
        return this.props.links.map(function (link, i) {
          if (!link.href) {
            return _react2.default.createElement(
              'span',
              { key: i },
              _react2.default.createElement(
                'span',
                {
                  style: {
                    color: '#999',
                    fontSize: '14px',
                    textDecoration: 'none',
                    letterSpacing: '1.2px',
                    transition: 'all 0.2s ease-in-out'
                  }
                },
                link.text
              ),
              _react2.default.createElement('span', {
                style: {
                  color: '#999',
                  fontSize: '15px',
                  padding: '0 5px'
                }
              })
            );
          }

          return _react2.default.createElement(
            'span',
            { key: i },
            _react2.default.createElement(
              _Link2.default,
              {
                href: link.href,
                style: {
                  color: '#999',
                  fontSize: '14px',
                  textDecoration: 'none',
                  letterSpacing: '1.2px',
                  transition: 'all 0.2s ease-in-out',
                  display: 'block',
                  paddingLeft: '15px'
                },
                hoverStyles: {
                  color: '#00a9f2'
                }
              },
              link.text
            ),
            _react2.default.createElement('span', {
              style: {
                color: '#999',
                fontSize: '15px',
                padding: '10px 5px',
                display: 'block'
              }
            })
          );
        }.bind(this));
      }
    }, {
      key: 'renderButton',
      value: function renderButton() {
        if (!this.props.isMobile || typeof navigator === 'undefined') {
          return false;
        }

        var href = '';

        if (typeof navigator !== 'undefined' && (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i))) {
          href = this.props.mobileAppText.itunes && encodeURI(this.props.mobileAppText.itunes) || 'itms://itunes.apple.com/us/app/concur-travel-receipts-expense/id335023774?mt=8/';
        } else if (typeof navigator !== 'undefined' && navigator.userAgent.match(/Android/i)) {
          href = this.props.mobileAppText.android && encodeURI(this.props.mobileAppText.android) || 'https://play.google.com/store/apps/details?id=com.concur.breeze';
        }

        if (!href) {
          return false;
        }

        return _react2.default.createElement(
          'div',
          { style: {
              margin: '48px 0'
            } },
          _react2.default.createElement(
            'a',
            {
              className: 'visible-xs mobile-support-link',
              href: href,
              style: {
                margin: '30px 15px',
                clear: 'both',
                color: '#f0ab00',
                borderColor: '#f0ab00'
              }
            },
            this.props.mobileAppText.text
          )
        );
      }
    }, {
      key: 'render',
      value: function render() {
        var styles = {
          clear: 'both',
          backgroundColor: '#000',
          width: 'calc(100% + 30px)',
          margin: '20px 0 0 -15px'
        };

        return _react2.default.createElement(
          'div',
          {
            className: 'col-sm-12 text-left support-links hidden-lg',
            style: this.props.isMobile ? styles : {}
          },
          this.renderButton(),
          this.buildLinks()
        );
      }
    }]);

    return SupportLinks;
  }(_react2.default.Component);

  exports.default = SupportLinks;


  SupportLinks.propTypes = {
    links: _propTypes2.default.array,
    isMobile: _propTypes2.default.bool,
    mobileAppText: _propTypes2.default.object
  };

  SupportLinks.defaultProps = {
    links: [],
    mobileAppText: {
      text: 'GET CONCUR MOBILE APP'
    }
  };
});